module.exports = __webpack_public_path__ + "img/img-full-copy@3x.6b11a912.jpg";